<div class="card kpi-red"  (click)="optimizeEfficiency()">
    <div class="card-body kpi-card">
        <h5 class="card-title">Simulateur de négociation</h5>
        <p class="card-value">
            Ouvrir
        </p>
    </div>
</div>
